import { Loader } from '@nile/components';
import RandomText from '@nile/components/src/Components/AI/components/RandomText';
import React from 'react';

const InlineLoader = ({ text, variation }) => {
  return (
    <div className="flex col g10 actr w100 pt10 pb10 jctr ai-inline-loader">
      <div>
        <Loader />
      </div>
      <div className="fsize12">
        <RandomText variation={variation} text={text} />
      </div>
    </div>
  );
};

export default InlineLoader;
